import React from 'react';
import Navbar from '../components/Navbar';
import Services from '../components/Services';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';
import SEOHelmet from '../components/SEOHelmet';
import { pagesSEO } from '../utils/seoConfig';

const ServicesPage = () => {
  return (
    <div className="services-page">
      <SEOHelmet 
        title={pagesSEO.services.title}
        description={pagesSEO.services.description}
        keywords={pagesSEO.services.keywords}
        canonical={pagesSEO.services.canonical}
      />
      <Navbar />
      <Breadcrumb />
      <main>
        <h1 className="page-title sr-only">設計服務 - 聯漢室內設計工作室</h1>
        <Services />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage; 